import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export { extractApiErrorMessage } from './api-error.helper';

export function passwordsMatchValidator(
  newField = 'new_password',
  confirmField = 'confirm_password',
): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const newPassword = group.get(newField)?.value as string | undefined;
    const confirmPassword = group.get(confirmField)?.value as string | undefined;
    if (!newPassword || !confirmPassword) {
      return null;
    }
    return newPassword === confirmPassword ? null : { passwordMismatch: true };
  };
}

/**
 * Group-level validator ensuring the new password differs from the current one.
 * Returns null (passes) when either field is empty so it doesn't fire prematurely,
 * or when the form has no current-password field (e.g. token-based reset flows).
 */
export function passwordDifferentFromCurrentValidator(
  currentField = 'current_password',
  newField = 'new_password',
): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const currentPassword = group.get(currentField)?.value as string | undefined;
    const newPassword = group.get(newField)?.value as string | undefined;
    if (!currentPassword || !newPassword) {
      return null;
    }
    return currentPassword === newPassword ? { sameAsCurrent: true } : null;
  };
}

export function passwordPolicyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string;
    if (!value) {
      return null;
    }
    const errors: ValidationErrors = {};
    if (!/[A-Z]/.test(value)) {
      errors['noUppercase'] = true;
    }
    if (!/[a-z]/.test(value)) {
      errors['noLowercase'] = true;
    }
    if (!/\d/.test(value)) {
      errors['noDigit'] = true;
    }
    if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value)) {
      errors['noSpecialChar'] = true;
    }
    return Object.keys(errors).length > 0 ? errors : null;
  };
}
